import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';

import Dialog, { DialogTitle, DialogContentText,DialogContent,DialogActions } from 'material-ui/Dialog';

import Typography from 'material-ui/Typography/Typography';

const styles = theme => ({
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display:'inline-flex',
      },
});

class MessageBoxYesNo extends Component {
        render = ()=>
        {
            const {classes} = this.props;

            return (
                <div>
                    
            <Dialog
            open={true}
            aria-labelledby="form-dialog-title"
            classes={classes}
            >
            <DialogTitle>{this.props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {this.props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={this.props.onAction.bind(this,false)} color="primary" className={classes.button} >
                NO
            </Button>
            <div className={classes.wrapper}>
                <Button 
                color="primary" className={classes.button} onClick={this.props.onAction.bind(this,true)}>
                YES
                </Button>
            </div>
            </DialogActions>
            </Dialog>            
            </div>
            )
        }
}

export default withStyles(styles)(MessageBoxYesNo);


// WEBPACK FOOTER //
// ./src/admin/MessageBoxYesNo.js